import { Card, Label, HelpIndicator } from "@jsq/ds/core";
import { FormRadioBar, useFormContext } from "@jsq/ds/forms";
import { SPACING } from "~/styles/variables";
import AddressFields from "../../CaseDetailsDrawer/Profiles/common/AddressFields";
import EntityFields from "../../CaseDetailsDrawer/Profiles/common/EntityFields";
import IndividualFields from "../../CaseDetailsDrawer/Profiles/common/IndividualFields";
import { useComplianceAiExtraction } from "../../flags";
import { FormValues } from "../types";
import { cardStyle } from "./styles_vanilla.css";

const InvestorAccountCard = ({
  inAiExtractionMode = true,
}: {
  inAiExtractionMode?: boolean;
}) => {
  const { values } = useFormContext<FormValues>();
  const aiExtractionSupported = useComplianceAiExtraction();

  const isEntity = values.accountType === "institution";

  const isAccountTypeDisabled = !values.client || !values.entity;

  const radioBar = (
    <FormRadioBar
      name="accountType"
      style={{ maxWidth: "250px" }}
      options={[
        { label: "Entity", value: "institution", isDisabled: isAccountTypeDisabled },
        { label: "Individual", value: "individual", isDisabled: isAccountTypeDisabled },
      ]}
    />
  );

  return (
    <Card title="Investor account" className={cardStyle}>
      <Label>Account type</Label>
      {isAccountTypeDisabled ? (
        <HelpIndicator
          id="account-type-disabled-tooltip"
          placement="top"
          content="Please fill in the case information."
        >
          <div>{radioBar}</div>
        </HelpIndicator>
      ) : (
        radioBar
      )}
      {values.accountType && (
        <>
          <div style={{ marginBottom: SPACING.MEDIUM }} />
          {isEntity ? (
            <EntityFields
              inAiExtractionMode={inAiExtractionMode}
              aiExtractionSupported={aiExtractionSupported}
            />
          ) : (
            <>
              <IndividualFields
                includeTitle={false}
                inAiExtractionMode={inAiExtractionMode}
                aiExtractionSupported={aiExtractionSupported}
              />

              <AddressFields aiExtractionSupported={aiExtractionSupported} />
            </>
          )}
        </>
      )}
    </Card>
  );
};

export default InvestorAccountCard;
